import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  input: {
    marginTop: 16,
    marginBottom: 8,
  },
});
